<template>
  <el-collapse v-model="activeTab">
    <el-collapse-item :title="$t('text.legend')" name="legend">
      <div class="legend mt-10">
        <div class="legend-group">
          <div class="legend-item-wrapper">
            <div class="legend-item">
              <div class="pad-cycle"></div>
              <div class="legend-item-text">
                {{ $t('text.pad_cycle', { pad: $store.state.locale.pad }) }}
              </div>
            </div>
            <div class="legend-item">
              <div class="off-body-item">
                <div class="off-body-left"></div>
                <img src="@/assets/image/VoidingPatternIcon/off-body.svg" />
                <div class="off-body-right"></div>
              </div>
              <div class="legend-item-text">
                {{ $t('text.off_body') }}
              </div>
            </div>
          </div>
        </div>
        <div class="legend-group">
          <div class="legend-item-wrapper">
            <div class="legend-item">
              <div class="diaper-not-selected">
                <img
                  src="@/assets/image/VoidingPatternIcon/diaper-not-selected.png"
                />
              </div>
              <div class="legend-item-text">
                {{
                  $t('text.diaper_not_selected', {
                    pad: $store.state.locale.pad
                  }).toLowerCase()
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="legend-group">
          <div class="legend-item-wrapper">
            <div class="legend-item">
              <div>
                <div class="pad-fullness">
                  <img
                    src="@/assets/image/VoidingPatternIcon/pad-fullness1.png"
                  />
                </div>
                <div class="pad-fullness">
                  <img
                    src="@/assets/image/VoidingPatternIcon/pad-fullness2.png"
                  />
                </div>
                <div class="pad-fullness">
                  <img
                    src="@/assets/image/VoidingPatternIcon/pad-fullness3.png"
                  />
                </div>
                <div class="pad-fullness">
                  <img
                    src="@/assets/image/VoidingPatternIcon/pad-fullness4.png"
                  />
                </div>
                <div class="pad-fullness">
                  <img
                    src="@/assets/image/VoidingPatternIcon/pad-fullness5.png"
                  />
                </div>
              </div>
              <div class="legend-item-text">
                {{ $t('text.pad_capacity', { pad: $store.state.locale.pad }) }}
              </div>
            </div>
            <div class="legend-item">
              <div class="void-event">
                <img src="@/assets/image/VoidingPatternIcon/small-void.png" />
              </div>
              <div class="void-event">
                <img src="@/assets/image/VoidingPatternIcon/medium-void.png" />
              </div>
              <div class="void-event">
                <img src="@/assets/image/VoidingPatternIcon/large-void.png" />
              </div>
              <div class="legend-item-text">
                {{ $t('text.void_event_size') }}
              </div>
            </div>
          </div>
        </div>
        <div class="legend-group">
          <div class="legend-item-wrapper">
            <div class="legend-item">
              <div class="lost-pod-connection-item"></div>
              <div class="legend-item-text">
                {{ $t('text.out_of_range_legend').toLowerCase() }}
              </div>
            </div>
            <div class="legend-item">
              <div class="external-humidity">
                <img
                  src="@/assets/image/VoidingPatternIcon/external-humidity.png"
                />
              </div>
              <div class="legend-item-text">
                {{ $t('text.external_humidity').toLowerCase() }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="legend-group"
          v-for="legend in additionalLegends"
          :key="legend.Id"
        >
          <div class="legend-item-wrapper">
            <div class="legend-item additional-legend pointer">
              <div
                class="image-wrapper"
                :class="{
                  'filter-selected': isFilterSelected(legend.Id)
                }"
                @click="updateFilters(legend.Id)"
              >
                <img :src="legend.Url" />
              </div>
              <div class="legend-item-text">
                {{ legend.Name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  props: {
    additionalLegends: {
      type: Array,
      require: true
    },
    expandLegend: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data() {
    return {
      selectedFilter: [],
      activeTab: ''
    }
  },
  computed: {
    isFilterSelected() {
      return val => {
        return this.selectedFilter.indexOf(val) > -1
      }
    }
  },
  mounted() {
    this.activeTab = this.expandLegend ? 'legend' : ''
  },
  watch: {
    additionalLegends: {
      handler() {
        this.selectedFilter = this.additionalLegends.map(item => item.Id)
      },
      immediate: true
    },
    selectedFilter() {
      this.$emit('updateData')
    }
  },
  methods: {
    updateFilters(val) {
      let index = this.selectedFilter.indexOf(val)
      if (index > -1) {
        this.selectedFilter.splice(index, 1)
      } else {
        this.selectedFilter.push(val)
      }
    }
  }
}
</script>
